(function (ng) {
    var DEFAULT_SORT_PROPERTY = '$index',
        defaultModel = {
            displayCompare: false,
            displayFacets: false,
            loading: false,
            openFacet: null,
            productPage: null,
            selectedProductPageId: null,
            sortProperty: DEFAULT_SORT_PROPERTY
        },
        selectors = {
            AddToPackageButton: '#btn-add-to-package',
            DocumentBody: document.body,
            CfBody: '.cf-body',
            CfSelection: '.cf-selection',
            Buckets: '.buckets',
            CurrentBucket: '.bucket.viewed',
            ErrorMessage: '.js-selection-error',
            Matrices: '.js-selection-matrix',
            MatrixOptions: '.js-selection-matrix-option',
            SkuErrorMessage: '.js-selection-error',
            NoProductsContainer: '.cf-no-product-selected',
            PackageBuilderContainer: '#package-builder-container',
            ProductPageWrapper: '.cf-product-page-wrapper',
            ProductResultsContainer: '.cf-product-results-container',
            ProductScrollContainer: '.cf-product-scroll-container',
            ProductScroll: '.product-scroll',
            ProductSummaryCard: '.cf-summary-product-card',
            ProductThumbContainer: '.package-product-thumb-container',
            SelectedItemId: '#pdpdp-selected-item-id',
            MobileShareInput: '.mobile-share .cf-share-input',
            DesktopShareInput: '.desktop-share .cf-share-input',
            SummaryWrapper: '.cf-summary-wrapper',
            ReviewsAccordionHeader: '.pdp-reviews .js-mobile-accordion-header',
            StickySidebar: '.js-sticky-sidebar',
            SuccessModalButton: '#success-modal-button',
            AddOnHeader: '.bucket-addon-header.desktop-accordion-header',
            ModalClose: '#dynamic-modal .modal-btn-close'
        };

    function getSelectedItemId() {
        /// <summary>
        /// Helper method that attempts to get the currently selected item id from the PDPDP. If one is not present, displays helper error messaging
        /// </summary>
        /// <returns type="Number">Returns the currently selected item id, if any</returns>
        var selectedItemId = Number(ng.element(selectors.SelectedItemId).val());

        if (selectedItemId) {
            return selectedItemId;
        }

        ng.element(selectors.Matrices).not(':has(' + selectors.MatrixOptions + ':checked)').find(selectors.SkuErrorMessage).show();

        return 0;
    }

    ng.module('evo.Packages.Controllers').controller('packageBuilderController', ['$document', '$interval', '$location', '$scope', '$timeout', '$window', 'bucketResultsService', 'cartService', 'CHECKOUT_ENDPOINT', 'productPageService', 'successMessageService',
        function ($document, $interval, $location, $scope, $timeout, $window, bucketResultsService, cartService, CHECKOUT_ENDPOINT, productPageService, successMessageService) {
            var self = this,
                lastSelectedItemId = 0,
                model = { loading: true, initialLoad: false, productPageLoading: false, productAdded: false, Products: [], currentFacet: '', bucketLoading: false, bucketLoadingName: '', shareActive: false, disableCompare: false, compareHeight: 0, expandProducts: false, messageIntro: '', addOnsExist: false, addOnsComplete: false, addOnsExpanded: false, addingProduct: false, currentProductAdded: false, fadeInMessage: false, fadeOutMessage: false, filterTotalCount: 0, windowWidth: 0, successModalFired: false },
                currentDocHeight = ng.element($document).height(),
                mobileBreakpoint = 1024,
                latestDocHeight,
                latestWindowWidth,
                desktopSidebarStickyInit = false;

            $scope.model = model;

            // A list of available facet ids, which the frontend can iterate over
            model.availableFacets = [];
            // track which facet is open.  This will be a lookup by $index
            model.openFacets = {};

            function loadMoreProducts(model, index) {
                var numberAdded = 0;
                while (model.AdditionalProducts.length > index && numberAdded++ < 15) {
                    model.Products.push(model.AdditionalProducts[index++]);
                }
                if (model.AdditionalProducts.length > index) {
                    $timeout(function () { loadMoreProducts(model, index); }, 100);
                }
            }

            function mergeModel(originalModel, newModel) {
                /// <summary>
                /// update the "originalModel" object with values from the newModel
                /// manually updates facets and buckets to prevent ng-animate interference
                /// </summary>

                for (var i = 0; i < (originalModel.Buckets || []).length; i++) {
                    var b = originalModel.Buckets[i];
                    if (!newModel.Buckets.find(function (nb) {
                        return nb.PackageBucketId === b.PackageBucketId;
                    })) {
                        originalModel.Buckets.splice(i--, 1);
                    }
                }

                for (var i = 0; i < (originalModel.Facets || []).length; i++) {
                    var f = originalModel.Facets[i];
                    if (!newModel.Facets.find(function (nf) {
                        if (nf.FacetId === f.FacetId) {
                            (f.Values || []).length = 0;
                            return true;
                    }
                    })) {
                        originalModel.Facets.splice(i--, 1);
                    }
                }

                originalModel.AdditionalProducts = newModel.Products;
                originalModel.Products.length = 0;
                loadMoreProducts(originalModel, 0);

                delete newModel.Products;

                newModel.selectedProductPageId = null;

                ng.merge(originalModel, newModel);
            }

            self.applyFacets = function (facet) {
                /// <summary>
                /// Updates the current view model to reflect a change in facet selections
                /// </summary>

                model.loading = true;
                model.currentFacet = facet;
                bucketResultsService.applyFacets(model.Facets).then(function (results) {
                    ng.extend(results, defaultModel);
                    delete results.displayCompare;
                    delete results.displayFacets;
                    delete results.openFacet;
                    delete results.sortProperty;

                    mergeModel(model, results);

                    setFilterCounts();

                    model.currentFacet = null;
                });
            };

            self.checkout = function ($event) {
                /// <summary>
                /// Adds all the items currently selected by the user to their cart and redirects them to the checkout page
                /// </summary>

                $event.preventDefault();

                var selectedItems = [];
                ng.forEach(model.Buckets, function (b) {
                    if (b.ChosenItem) {
                        var item = {
                            itemId: b.ChosenItem.ItemId,
                            sku: b.ChosenItem.SKU,
                            productDetailsRelativePath: b.ChosenItem.ProductDetailsRelativePath,
                            productPageId: b.ChosenItem.ProductPageId,
                            brandName: b.ChosenItem.BrandName
                        };
                        selectedItems.push(item);
                    }
                });

                if (!selectedItems.length) {
                    return;
                }

                cartService.addItems(selectedItems).then(function () {
                    $window.location.href = CHECKOUT_ENDPOINT;
                });
            };

            self.getCurrentTabIndex = function () {
                /// <summary>
                /// Gets the index of the currently selected bucket / tab
                /// </summary>
                for (var i = 0; i < model.Buckets.length; i++) {
                    if (model.Buckets[i].Viewed === true)
                        return i;
                }
            };

            self.getCurrentAddOnIndex = function () {
                var i = -1;
                for (var j = 0; j < model.Buckets.length; j++) {
                    if (!model.Buckets[j].DisplayByDefault)
                        i++;
                    if (model.Buckets[j].Viewed === true)
                        return i;
                }
            };

            self.getAllSpecNames = function () {
                /// <summary>
                /// Returns the set of unique spec names amongst our products
                /// </summary>
                var uniqueKeys = {
                };
                ng.forEach(model.Products, function (p) {
                    ng.extend(uniqueKeys, p.Specs);
                });

                //convert the unique properties to a sorted array
                var sortedKeys = [];
                ng.forEach(uniqueKeys, function (val, key) {
                    sortedKeys.push(key);
                });
                sortedKeys.sort();

                return sortedKeys;
            };

            self.getLastChosenItem = function () {
                /// <sumamry>
                /// Get the most recently added item, or null if no items have been selected in this session
                /// </summary>
                if (!model || !model.Buckets)
                    return null;

                var bucket = model.Buckets.find(function (b) {
                    return b.ChosenItem && b.ChosenItem.ItemId === lastSelectedItemId;
                });
                return bucket && bucket.ChosenItem || null;
            };

            self.getNumberOfChosenItems = function () {
                /// <summary>
                /// Returns the number of selected items thusfar
                /// </summary>
                /// <returns type="Number">The number of items selected</returns>

                var num = 0;
                ng.forEach(model.Buckets, function (b) {
                    if (b.ChosenItem) {
                        num++;
                    }
                });

                return num;
            };

            self.getPackageTotal = function () {
                /// <summary>
                /// Returns the dollar total of selected items thusfar
                /// </summary>
                /// <returns type="Number">The current price of the package</returns>

                var total = 0;
                ng.forEach(model.Buckets, function (b) {
                    if (b.ChosenItem) {
                        total += b.ChosenItem.Price;
                    }
                });

                return total;
            };

            self.removeChosenItem = function ($event, bucket) {
                /// <summary>
                /// Removes the chosen item value for the given bucket
                /// </summary>

                if (bucket && bucket.ChosenItem) {
                    $event.stopPropagation();
                    $event.preventDefault();
                    bucketResultsService.removeItem(bucket.ChosenItem.ItemId);
                    model.currentFacet = null;
                    bucketResultsService.viewBucket().then(function (results) {
                        ng.extend(results, defaultModel);
                        mergeModel(model, results);

                        setFilterCounts();
                        model.openFacets = {};
                    });
                    bucket.ChosenItem = null;
                }
            };

            self.scrollProductContainerLeft = function () {
                ng.element(selectors.ProductScroll).animate({
                    scrollLeft: 0
                }, 500);
            };

            self.buildShareContainer = function ($event, screenSize) {
                $event.preventDefault();
                $event.stopPropagation();
                model.productAdded = false;
                var shareURL = window.location;
                if (screenSize === 'mobile') {
                    ng.element(selectors.MobileShareInput).val(shareURL).select();
                }
                else {
                    ng.element(selectors.DesktopShareInput).val(shareURL).select();
                }

                model.shareActive = true;
            };

            self.autoSelect = function ($event) {
                $event.stopPropagation();
                $event.target.select();
            };

            self.displayChosenProduct = function (bucket) {
                //display chosen product page and scroll to proper product
                ng.forEach(model.AdditionalProducts, function (product, productIndex) {
                    if (product.ItemIds.indexOf(bucket.ChosenItem.ItemId) > -1) {
                        model.currentProductAdded = true;
                        self.viewProductPage(product);

                        function scrollToProductThumb() {
                            //due to the lazy loading of product data,
                            //it's possible that the thumb hasn't been merged yet
                            //so we need to continue to wait until the data is loaded
                            if (productIndex >= model.Products.length) {
                                $timeout(scrollToProductThumb, 100);
                                return;
                            }

                            var productThumbWidth = ng.element(selectors.ProductThumbContainer).width(),
                                windowWidth = ng.element($window).width() / 2,
                                productThumbOffset = productThumbWidth / 2,
                                productScrollPosition = productThumbWidth * productIndex - windowWidth - productThumbOffset;

                            ng.element(selectors.ProductScroll).animate({
                                scrollLeft: productScrollPosition
                            }, 50);
                        }
                        scrollToProductThumb();

                        return false;
                    }
                });
            };

            self.setCompareHeight = function (compareHeight) {
                if (model.displayCompare) {
                    ng.element(selectors.ProductScrollContainer).height(compareHeight);
                }
                else {
                    ng.element(selectors.ProductScrollContainer).attr('style', '');
                }
            };

            self.setCompareState = function () {
                ng.element(selectors.ProductScrollContainer).attr('style', '');

                //if no compare specs, then disable compare
                var compareSpecsCount = self.getAllSpecNames().length;
                if (compareSpecsCount > 0) {
                    model.disableCompare = false;
                    //set compare height based on count
                    model.compareHeight = 41 * compareSpecsCount + ng.element(selectors.ProductScrollContainer).height();
                }
                else {
                    model.disableCompare = true;
                }
            };

            self.openAddOns = function () {
                //find the next unselected default bucket
                var nextAddOn = model.Buckets.find(function (b) {
                    return !b.ChosenItem && !b.DisplayByDefault;
                });

                self.viewBucket(nextAddOn);

                model.addOnsExpanded = true;

                ng.element(selectors.ModalClose).trigger('click');

                var scrollPoint = latestWindowWidth >= mobileBreakpoint
                                    ? ng.element(selectors.CfBody).offset().top
                                    : ng.element(selectors.AddOnHeader).offset().top;

                //scroll to top of cf-body
                ng.element(selectors.DocumentBody).animate({
                    scrollTop: scrollPoint
                }, 500);
            };

            self.viewBucket = function (bucket) {
                /// <summary>
                /// Updates the current view model of buckets/facets/products/etc. to be the new bucket
                /// </summary>
                /// <param name="$event" type="Object">Click event data</param>
                /// <param name="bucket" type="Object">Package bucket to view</param>

                //If in mobile layout
                if (latestWindowWidth < mobileBreakpoint) {
                    if (bucket.Viewed) {
                        model.expandProducts = !model.expandProducts;
                        return;
                    }
                }

                //don't do anything if this bucket is already selected
                //(that would result in a needless call)
                if (bucket.Viewed)
                    return;

                model.bucketLoadingName = bucket.Name;
                model.productPageLoading = true;
                model.currentProductAdded = false;
                model.fadeOutMessage = true;
                model.loading = true;
                model.bucketLoading = true;

                bucketResultsService.viewBucket(bucket.PackageBucketId).then(function (results) {
                    ng.extend(results, defaultModel);
                    mergeModel(model, results);

                    self.setCompareState();
                    updateMessageIntro(false);

                    setFilterCounts();

                    checkForAddOns();

                    //collapse filter and compare sections
                    collapseCompareFilters();

                    if (bucket.ChosenItem) {
                        self.displayChosenProduct(bucket);
                    }
                    else {
                        //ensure the product-scroll section is scrolled to beginning
                        ng.element(selectors.ProductScroll).scrollLeft(0);
                    }

                    //delay for effect, and to allow product images to load
                    $timeout(function () {
                        model.expandProducts = true;
                        model.bucketLoading = false;
                    }, 200);
                });
            };

            self.viewProductPage = function (product) {
                /// <summary>
                /// Displays the paired down product page for the given product
                /// </summary>
                /// <param name="$event" type="Object">Click event data</param>
                /// <param name="product" type="Object">Product to view</param>

                //If the product is not already selected, load the new product page
                if (model.selectedProductPageId !== product.ProductPageId) {
                    model.selectedProductPageId = product.ProductPageId;
                    model.loading = true;
                    model.productPageLoading = true;
                    model.currentProductAdded = false;

                    //slight delay to allow the product page to animate in/out
                    $timeout(function () {
                        //if the product has already been selected, set that variable
                        ng.forEach(model.Buckets, function (bucket) {
                            if (bucket.Viewed && bucket.ChosenItem && product.ItemIds.indexOf(bucket.ChosenItem.ItemId) > -1) {
                                model.currentProductAdded = true;
                            }
                        });

                        productPageService.getProductPage(product.ProductPageId).then(function (pageHtml) {
                            model.productPage = {
                                filteredItemIds: product.FilteredItemIds,
                                html: pageHtml,
                                itemIds: product.ItemIds,
                                productPageId: product.ProductPageId
                            };
                            model.loading = false;
                            model.productPageLoading = false;
                        });
                    }, 500);
                }
            };

            self.scrollToProductPage = function () {
                var productContainerTop = ng.element(selectors.ProductResultsContainer).offset().top,
                    currentScrollPosition = ng.element(selectors.DocumentBody).scrollTop();

                if (productContainerTop > currentScrollPosition) {
                    //delay for effect
                    $timeout(function () {
                        //scroll to top of product results container

                        ng.element(selectors.DocumentBody).animate({
                            scrollTop: productContainerTop
                        }, 500);
                    }, 500);
                }
            };

            function updateMessageIntro(showText) {
                model.fadeInMessage = false;
                model.fadeOutMessage = false;
                model.messageIntro = showText ? successMessageService.getRandomMessage() : '';

                $timeout(function () {
                    model.fadeInMessage = true;
                }, 400);
            }

            function setFilterCounts() {
                var filterTotal = 0;
                ng.forEach(model.Facets, function (facet) {
                    facet.selectedCount = 0;

                    ng.forEach(facet.Values, function (facetValue) {
                        if (facetValue.Selected) {
                            facet.selectedCount++;
                            filterTotal++;
                        }
                    });
                });
                model.filterTotalCount = filterTotal;
            }

            function setProductPageHeight() {
                var productResultsContainerHeight = ng.element(selectors.ProductResultsContainer).height(),
                windowHeight = ng.element($window).height(),
                summaryWrapperHeight = ng.element(selectors.SummaryWrapper).height(),
                bucketsHeight = ng.element(selectors.Buckets).height(),
                noProductPageWrapper = ng.element(selectors.NoProductsContainer),
                productPageWrapperHeight = windowHeight - bucketsHeight - productResultsContainerHeight - summaryWrapperHeight;

                noProductPageWrapper.css('height', productPageWrapperHeight);
            }

            function reinitWaypoints() {
                Waypoint.refreshAll();
            }

            function collapseCompareFilters() {
                model.displayFacets = false;
                model.displayCompare = false;
            }

            function checkForAddOns() {
                //if there are addons, show them
                var addOnCheck = false;
                ng.forEach(model.Buckets, function (bucket) {
                    if (!bucket.DisplayByDefault) {
                        model.addOnsExist = true;
                        addOnCheck = true;
                        return;
                    }
                });
                if (!addOnCheck) {
                    model.addOnsExist = false;
                }
            }

            //reinit certain styles/functions on page anytime the DOM height changes
            $interval(function () {
                latestDocHeight = ng.element($document).height();
                latestWindowWidth = ng.element($window).width();

                //doc height has changed
                if (latestDocHeight !== currentDocHeight) {
                    reinitWaypoints();
                    setProductPageHeight();

                    if (desktopSidebarStickyInit) {
                        ng.element(selectors.DocumentBody).trigger("sticky_kit:recalc");
                    }
                }

                //window width is desktop dimensions
                if (latestWindowWidth >= mobileBreakpoint) {
                    model.expandProducts = true;

                    //if sticky kit is not active on the sidebar, reactivate it
                    if (!desktopSidebarStickyInit) {
                        ng.element(selectors.StickySidebar).stick_in_parent();
                        desktopSidebarStickyInit = true;
                    }
                }
                    //window width is mobile dimensions
                else {
                    //if sticky kit is active on the sidebar, detach it
                    if (desktopSidebarStickyInit) {
                        ng.element(selectors.StickySidebar).trigger('sticky_kit:detach');
                        desktopSidebarStickyInit = false;
                    }
                }
                model.windowWidth = latestWindowWidth;
                currentDocHeight = latestDocHeight;
            }, 100);

            ng.element(selectors.PackageBuilderContainer)
                //listen for the "Add to Package" button click
                    //should add the currently selected item to the user's package
                .on('click', selectors.AddToPackageButton, function (e) {
                    model.loading = true;
                    var selectedItemId = getSelectedItemId();
                    if (!selectedItemId) {
                        return;
                    }
                    model.addingProduct = true;
                    bucketResultsService.selectItem(selectedItemId);
                    lastSelectedItemId = selectedItemId;

                    //in order to figure out the next un-selected bucket,
                    //we need to re-query the current bucket now that the selection has been made
                    //this is to prevent the scenario where the newly selected item does not
                    //share collections with the first un-selected bucket
                    var currentBucket = model.Buckets.find(function (b) {
                        return b.Viewed;
                    });

                    bucketResultsService.viewBucket(currentBucket.PackageBucketId).then(function (currentResults) {
                        if (!currentResults) {
                            console.warn('Error retrieving results');
                            return;
                        }

                        //delay for effect
                        $timeout(function () {
                            model.fadeOutMessage = true;

                            //find the next unselected default bucket
                            var unselectedDefaultBucket = currentResults.Buckets.find(function (b) {
                                return !b.ChosenItem && b.DisplayByDefault;
                            });

                            //continue to next unselected default bucket
                            if (unselectedDefaultBucket) {
                                model.loading = true;
                                bucketResultsService.viewBucket(unselectedDefaultBucket.PackageBucketId).then(function (results) {
                                    if (results) {
                                        model.addingProduct = false;
                                        model.currentProductAdded = true;
                                        updateDisplay(results);
                                    }
                                });
                            }
                            else {
                                model.addingProduct = false;
                                model.currentProductAdded = true;

                                if (model.addOnsExist && model.successModalFired) {
                                    //find the next unselected add-on bucket
                                    var unselectedAddOnBucket = currentResults.Buckets.find(function (b) {
                                        return !b.ChosenItem && !b.DisplayByDefault;
                                    });

                                    if (unselectedAddOnBucket) {
                                        model.loading = true;
                                        bucketResultsService.viewBucket(unselectedAddOnBucket.PackageBucketId).then(function (results) {
                                            if (results) {
                                                model.addingProduct = false;
                                                model.currentProductAdded = true;
                                                updateDisplay(results);

                                                $timeout(function () {
                                                    //if desktop layout, scroll selection container to show selected addon
                                                    if (latestWindowWidth >= mobileBreakpoint) {
                                                        var scrollPoint = 0,
                                                            offset = 90;
                                                        ng.element(selectors.Buckets).find('.bucket').each(function () {
                                                            var thisBucket = ng.element(this);

                                                            scrollPoint = scrollPoint + thisBucket.outerHeight();

                                                            if (thisBucket.hasClass('viewed')) {
                                                                return false;
                                                            }
                                                        });

                                                        //scroll to top of cf-body
                                                        ng.element(selectors.Buckets).animate({
                                                            scrollTop: scrollPoint - offset
                                                        }, 300);
                                                    }
                                                }, 500);
                                            }
                                        });
                                    }
                                    else {
                                        model.addOnsComplete = true;
                                        model.successModalFired = false;
                                    }
                                }

                                //fire the success modal if it has not been launched already
                                if (!model.successModalFired) {
                                    $timeout(function () {
                                        ng.extend(currentResults, defaultModel);
                                        mergeModel(model, currentResults);

                                        $timeout(function () {
                                            ng.element(selectors.SuccessModalButton).trigger('click');
                                            model.successModalFired = true;
                                        }, 500);
                                    }, 300);
                                }
                                else {
                                    updateDisplay(currentResults);
                                }
                            }
                        }, 100);

                        //scroll page up to buckets, show product added card, slight delay for effect
                        function updateDisplay(results) {
                            $timeout(function () {
                                ng.extend(results, defaultModel);
                                mergeModel(model, results);

                                var scrollPoint = latestWindowWidth >= mobileBreakpoint
                                    ? ng.element(selectors.CfBody).offset().top
                                    : ng.element(selectors.CurrentBucket).offset().top;

                                //scroll to top of cf-body
                                ng.element(selectors.DocumentBody).animate({
                                    scrollTop: scrollPoint
                                }, 500);

                                //collapse filter and compare sections, and set compare state
                                collapseCompareFilters();
                                self.setCompareState();
                                setFilterCounts();
                                checkForAddOns();

                                //ensure the product-scroll section is scrolled to beginning
                                ng.element(selectors.ProductScroll).scrollLeft(0);

                                //Delay after scroll
                                $timeout(function () {
                                    updateMessageIntro(true);
                                }, 300);
                            }, 300);
                        }
                    });
                });

            //initialize the page
            bucketResultsService.viewBucket().then(function (results) {
                ng.extend(results, defaultModel);

                var currentBucket = results.Buckets.find(function (b) {
                    return b.Viewed;
                });

                var bucketToShow = currentBucket.ChosenItem ? results.Buckets.find(function (b) {
                    return b != currentBucket && b.DisplayByDefault && !b.ChosenItem;
                }) : null;

                if (bucketToShow) {
                    self.viewBucket(bucketToShow);
                }
                else {
                    mergeModel(model, results);

                    self.setCompareState();
                    setFilterCounts();
                    updateMessageIntro(false);

                    if (currentBucket.ChosenItem) {
                        self.displayChosenProduct(currentBucket);
                    }
                }

                //init the height of the product page
                setProductPageHeight();

                checkForAddOns();

                model.initialLoad = true;

                //Slight delay for initalLoad state to control animation flow
                $timeout(function () {
                    ng.element(selectors.StickySidebar).stick_in_parent();
                    desktopSidebarStickyInit = true;
                }, 750);
            });
        }
    ]).config(['$animateProvider', '$locationProvider', function ($animateProvider, $locationProvider) {
        // don't animate elements with the 'no-animate' class
        $animateProvider.classNameFilter(/^((?!no-animate).)*$/);

        $locationProvider.html5Mode({
            enabled: true, requireBase: false, rewriteLinks: false
        });
    }]);
})(angular);